import { z } from 'zod';
import { isValidObjectIdSchema } from '../utils/index.js';

const baseSchema = z.object({
  _id: z.string()
});
const baseFESchema = baseSchema.extend({
  _id: isValidObjectIdSchema
});

export { baseFESchema, baseSchema };
